/**
 * Clone this to config.js and set appropriate values
 */
export default {
  paymentcloud: {
    STRATUS_URL: 'https://stagingportal.paymentcloudinc.com/',
    MAIN_URL: 'https://staging.paymentcloudinc.com/',
    APPLICATION_URL: 'https://staging.paymentcloudinc.com/',
    STRATUS_APPLICATION_URL: 'https://staging.paymentcloudinc.com/',
    PUSHER_KEY: '33dd3e3ef9759006bc77',
    PUSHER_CLUSTER: 'mt1',
    RESIDUAL_SYSTEM: [272, 1, 2, 1197],
    HIDE_APPLICATION_USER_ID: 1460,
    EMS_ORG_ID: 557,
    ENABLE_ESIGN_ON_ROUTE: ["mwright", "an", "nhamou", "adelzer", "asethh", "jhillis"],
    GOOGLE_API_KEY: "AIzaSyC1vqtDNH2r2YdwppicGtcQtN64jNhxaOk",
    PAYCHEX_ORG_ID: 558,
    GOOGLE_CAPTCHA: '6LcxFwYrAAAAALO4PYlrRBzxLHV4y_rci5V6C9Jv',
  },
};
